import { keyframes } from "@emotion/react";
import {
  LoadingIcon,
  BaseballIcon,
  BasketballIcon,
  FootballIcon,
  HockeyIcon,
  SoccerIcon,
} from "@sidelinesports/icons";

const ICONS = {
  LoadingIcon,
  BaseballIcon,
  BasketballIcon,
  FootballIcon,
  HockeyIcon,
  SoccerIcon,
};

export const LoadingSpinner = ({
  icon = "Loading",
  size = "1.5rem",
}: {
  icon?:
    | "Loading"
    | "Baseball"
    | "Basketball"
    | "Football"
    | "Hockey"
    | "Soccer";
  size?: string;
}) => {
  const Component = ICONS[`${icon}Icon`];

  return (
    // This containing div is necessary to prevent a bug in Chrome where, if you
    // apply a rotation directly to the SVG, it causes the body background to
    // get saturated while the animation is active
    <div
      css={{
        height: size,
        width: size,
        position: "relative",
        backfaceVisibility: "hidden",
        animationDuration: "2s",
        animationName: spin,
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
        willChange: "transform",
      }}
    >
      <Component
        css={{
          fontSize: size,
          color: "white",
        }}
      />
    </div>
  );
};

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  70%, 100% {
    transform: rotate(360deg);
  }
`;
